var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0H3C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34315 18 3 18H15C16.6569 18 18 16.6569 18 15V3C18 1.34315 16.6569 0 15 0ZM3 2H15C15.5523 2 16 2.44772 16 3V11.36L12.8 8.63C11.7775 7.78866 10.3025 7.78866 9.28 8.63L2 14.7V3C2 2.44772 2.44772 2 3 2ZM3.56 16H15C15.5523 16 16 15.5523 16 15V14L11.49 10.16C11.2139 9.95499 10.8361 9.95499 10.56 10.16L3.56 16Z",
    fill: "#2E2B63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.5,
    r: 1.5,
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetImage);
export default __webpack_public_path__ + "static/media/getImage.9963efc1480c7163ccfb59b89d102259.svg";
export { ForwardRef as ReactComponent };